import 'core-js/stable';
import React from 'react';
import ReactDOM from 'react-dom';
import Events from './components/Events';
import 'whatwg-fetch'

const rootElement = document.getElementById('events-root');

if(rootElement) {
  fetch('/wp-json/wptheme/events')
    .then(response => response.json())
    .then(data => {
      ReactDOM.render(
        <React.StrictMode>
          <Events events={data}/>
        </React.StrictMode>,
        rootElement
      );
    });
}
